const sxStyles = (fullWidth) => ({
    buttonWrapper: {
        position: "relative",
        display: "inline-flex",
        width: fullWidth ? "100%" : "auto",
        overflow: "hidden",
    },
    loader: {
        position: "absolute",
        right: 0,
        bottom: 0,
        left: 0,
    },
});
export default sxStyles;
//# sourceMappingURL=Button.style.js.map